<div>
    <div class="managementtier-message">
        <p>Loading your Management Tools</p>
    </div>
    <br/><br/>
    <div class="managementtier-link">
        <p><a href="{{redirectUrl}}">Take me to the Management Tools</a></p>
    </div>
</div>